import { useCallback } from 'react';

import { useAuthorizedUser } from 'Services/User/useAuthorizedUser';
import { useWithAuthorizationCheck } from 'Shared/hooks/useWithAuthorizationCheck';

import { FollowUser } from './FollowUser';

import type { CommonFollowUserButtonPropsT } from './types';

type PropsT = Readonly<
  CommonFollowUserButtonPropsT & {
    readonly isLoading: boolean;
    readonly isFollowing: boolean;
    readonly toggleFollow?: () => Promise<void> | void;
  }
>;

export const FollowUserButton = (props: PropsT) => {
  const { isAuthorizationChecked, isAuthorized } = useAuthorizedUser();
  const {
    isFollowing,
    toggleFollow,
    rootClassName,
    moneSource,
    buttonType,
    dataTestId,
    size,
    wide,
    buttonTextType,
    onFollowClick,
    isLoading,
    shouldRemoveAllOnHistoryBack,
    user,
  } = props;

  const buttonIsLoading = isAuthorizationChecked && isAuthorized && isLoading;

  const handleClick = useCallback(() => {
    onFollowClick?.(isFollowing);

    toggleFollow?.();
  }, [isFollowing, onFollowClick, toggleFollow]);

  const executeIfAuthorized = useWithAuthorizationCheck(handleClick, {
    triggeredBy: moneSource,
    authType: 'signup',
    shouldRemoveAllOnHistoryBack,
  });

  return (
    <FollowUser
      buttonTextType={buttonTextType}
      buttonType={buttonType}
      dataTestId={dataTestId}
      isFollowing={isFollowing}
      isLoading={buttonIsLoading}
      rootClassName={rootClassName}
      size={size}
      userName={user.nick}
      wide={wide}
      onClick={executeIfAuthorized}
    />
  );
};
